import { render, staticRenderFns } from "./ProductInfoTablist.vue?vue&type=template&id=fde23692"
import script from "./ProductInfoTablist.vue?vue&type=script&lang=js"
export * from "./ProductInfoTablist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports